<template>
    <button @click="cancelRequest" type="button" class="btn btn-link-success font-weight-bold font-xs text-green">
        <slot >{{EnumLabels.CANCEL_AND_GOBACK_MERCHANT}}</slot>
    </button>
</template>
<script>
import { ERROR } from '../../mixins/error_codes.js';
import { EnumLabels } from '../../enums/CommonString.js';
export default {
    data() {
        return {
            EnumLabels,
        };
    },
    props: {
        eventName: {
            type: String,
            default: ""
        }
    },
    methods: {
        cancelRequest() {

            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event(this.eventName,g4Params) 

            var vm = this;
            axios
                .post("hcpay/cancel_request?tid=" + vm.$root.$data.tid)
                .then(response => {
                    if(vm.$root.transaction.hasOwnProperty('failedUrl') && vm.$root.transaction.failedUrl != 'undefined') {
                        window.location.href = vm.$root.transaction.failedUrl;
                    } else{
                        vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                    }
                })
                .catch(error => {
                    vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                });
        }
    },
}
</script>